import StageSubmissionView from "./StageSubmissionView";

export default function StageSubmissionsTab({
  stageAssignments,
  activeAssignments,
  stageDone = false,
}) {
  const allSubmissions = stageAssignments
    .flatMap((assignment) => assignment.taskSubmissions || [])
    .sort((a, b) => new Date(a.submittedAt) - new Date(b.submittedAt));

  if (!stageDone && activeAssignments.length === 0) {
    return (
      <div className="tab-empty">
        <p>No active assignments for this stage.</p>
      </div>
    );
  }

  if (allSubmissions.length === 0) {
    return (
      <div className="tab-empty">
        <p>No submissions yet.</p>
        <p className="small-muted">
          Waiting for {activeAssignments.length === 1 ? "the assignee" : "assignees"}
          {" "}to submit their work.
        </p>
      </div>
    );
  }

  return (
    <div className="stage-submissions-tab">
      <StageSubmissionView submissions={allSubmissions} />
    </div>
  );
}
